import AllYesNoCheckbox from "@app/components/all-yes-no-checkbox.tsx";
import FiltersContainer from "@app/components/filters-container.tsx";
import StaffChangePassword from "@app/components/modals/staff-change-password.tsx";
import PageTitle from "@app/components/page-title.tsx";
import { defaultStaffFilters } from "@app/constants/filters.defaults.tsx";
import useLookupListData from "@app/data-hooks/use-lookup-list-data.ts";
import useStaffData from "@app/data-hooks/use-staff-data.ts";
import { RouteHelper } from "@app/helpers/route-helper.ts";
import useAuth from "@app/hooks/use-auth.ts";
import { staffFiltersStore } from "@app/stores/filters.store.ts";
import { staffingTableDefinition } from "@app/table-definitions/staff-management.table-definition.tsx";
import { Button } from "@mui/material";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { DataTable, QueryStatusRouter, Select } from "bi-lib";
import { useState } from "react";

export const Route = createFileRoute("/_authenticated/_manager/staff/")({
    beforeLoad: RouteHelper.ManagerAuthGuard,
    component: Component,
});

function Component() {
    const [changePasswordId, setChangePasswordId] = useState<number>();

    const navigate = useNavigate();

    const filters = useStore(staffFiltersStore);

    const { deleteStaffMember, restoreStaffMember } = useStaffData();
    const { isAdmin } = useAuth();

    const { membershipRolesList } = useLookupListData();
    const { staffGrid } = useStaffData(filters);

    return (
        <>
            <StaffChangePassword
                id={changePasswordId}
                open={changePasswordId != undefined}
                onClose={() => setChangePasswordId(undefined)}
            />
            <PageTitle>Staff Management</PageTitle>
            <FiltersContainer onReset={() => staffFiltersStore.setState(() => defaultStaffFilters)}>
                <QueryStatusRouter queryHook={membershipRolesList}>
                    <Select
                        label={"Role"}
                        value={filters.roleId}
                        onChange={(e) => staffFiltersStore.setState(() => ({ ...filters, roleId: e! }))}
                        sx={{ minWidth: 150 }}
                        options={membershipRolesList.data?.map((x) => ({
                            label: x.roleName,
                            value: x.roleId ?? undefined,
                        }))}
                    />
                </QueryStatusRouter>
                <AllYesNoCheckbox
                    value={filters.activeState}
                    onChange={(value) => staffFiltersStore.setState(() => ({ ...filters, activeState: value }))}
                    label={"Active"}
                />
                <AllYesNoCheckbox
                    value={filters.hourlyState}
                    onChange={(value) => staffFiltersStore.setState(() => ({ ...filters, hourlyState: value }))}
                    label={"Hourly"}
                />
            </FiltersContainer>
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Staff"}
                actions={
                    <Link to={"/staff/create"}>
                        <Button variant="contained">Add New</Button>
                    </Link>
                }
                columns={staffingTableDefinition({
                    isAdmin: isAdmin,
                    onEdit: (id) => void navigate({ to: "/staff/$id", params: { id: id.toString() } }),
                    onDelete: (id) => deleteStaffMember.mutate(id),
                    onRestore: (id) => restoreStaffMember.mutate(id),
                    onChangePassword: (id) => setChangePasswordId(id),
                    rowCount: staffGrid.data?.length ?? 0,
                })}
                data={staffGrid.data ?? []}
                queryHook={staffGrid}
            />
        </>
    );
}
